import React from "react";
import { EventInstrument } from "../types/Instrument";

interface Props {
  instruments: EventInstrument[]; // Array of all available instruments
  currentInstrument: EventInstrument | undefined; // Currently selected instrument
  setCurrentInstrument: (instrument: EventInstrument | undefined) => void; // Setter function
}

const SimpleInstrumentDropdown: React.FC<Props> = ({
  instruments,
  currentInstrument,
  setCurrentInstrument,
}) => {
  const handleSelectionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = event.target.value;

    // Check if "All Instruments" is selected
    if (selectedId === "") {
      setCurrentInstrument(undefined); // Clear current instrument when "All Instruments" is selected
    } else {
      const selectedInstrument = instruments.find(
        (instrument) => instrument.instrument_id === selectedId
      );
      if (selectedInstrument) {
        setCurrentInstrument(selectedInstrument); // Set the selected instrument
      }
    }
  };

  return (
    <div style={{ width: "300px" }}>
      <label htmlFor="instrument-dropdown" style={{ display: "block", marginBottom: "2px" }}>
        Select Instrument
      </label>
      <select
        id="instrument-dropdown"
        value={currentInstrument?.instrument_id || ""}
        onChange={handleSelectionChange}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          background: "white",
        }}
      >
        <option value="">All Instruments</option>
        {instruments.map((instrument) => (
          <option key={instrument.instrument_id} value={instrument.instrument_id}>
            {instrument.instrument_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SimpleInstrumentDropdown;
